import { render, staticRenderFns } from "./MoveToCategoryDropdown.vue?vue&type=template&id=2ed2b4a1&scoped=true&"
import script from "./MoveToCategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./MoveToCategoryDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MoveToCategoryDropdown.vue?vue&type=style&index=0&id=2ed2b4a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2b4a1",
  null
  
)

export default component.exports